<template>
  <van-popup
    :value="popupShow"
    position="bottom"
    round
    :z-index="2000"
    :close-on-click-overlay="false"
    get-container="body"
    class="notice-popup"
  >
    <div class="notice-sheet">
      <div class="notice-header">
        <span class="notice-title">投诉须知</span>
        <img
          class="notice-close"
          referrerpolicy="no-referrer"
          src="https://lanhu-oss-2537-2.lanhuapp.com/SketchPng1274a3ba0b1e9695309821ed7ee603ebc6805191cb8a3d71b0615f5270b88d65"
          alt="关闭"
          @click="handleClose"
        />
      </div>
      <div class="notice-body">
        <p class="notice-content">{{ noticeContent }}</p>
      </div>
      <button
        class="notice-btn"
        :class="{ 'notice-btn-active': countdown <= 0 }"
        :disabled="countdown > 0"
        @click="handleConfirm"
      >
        {{ countdown > 0 ? `我知道了（${countdown}S）` : "我知道了" }}
      </button>
    </div>
  </van-popup>
</template>

<script>
import { NOTICE_CONTENT } from "../utils";

export default {
  name: "NoticePopup",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      popupShow: false,
      noticeContent: NOTICE_CONTENT,
      countdown: 3,
      timer: null,
    };
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        this.popupShow = val;
        if (val) {
          this.startCountdown();
        } else {
          this.stopCountdown();
        }
      },
    },
  },
  beforeDestroy() {
    this.stopCountdown();
  },
  methods: {
    startCountdown() {
      this.stopCountdown();
      this.countdown = 3;
      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown -= 1;
        } else {
          this.stopCountdown();
        }
      }, 1000);
    },
    stopCountdown() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    handleClose() {
      this.$emit("close");
    },
    handleConfirm() {
      if (this.countdown > 0) return;
      this.$emit("confirm");
    },
    restoreOverlay() {
      if (!this.visible) return;
      this.popupShow = false;
      this.$nextTick(() => {
        this.popupShow = true;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.notice-popup {
  max-height: 70vh;
}

.notice-sheet {
  padding: 24px 16px 40px;
  max-height: 70vh;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.notice-header {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin-bottom: 20px;
  flex-shrink: 0;
}

.notice-title {
  font-size: 16px;
  font-weight: 600;
  color: #000;
  line-height: 20px;
}

.notice-close {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  cursor: pointer;
}

.notice-body {
  flex: 1;
  overflow-y: auto;
  margin-bottom: 21px;
  -webkit-overflow-scrolling: touch;
}

.notice-content {
  margin: 0;
  font-size: 16px;
  line-height: 24px;
  color: #333;
  white-space: pre-wrap;
  font-weight: 500;
}

.notice-btn {
  width: 100%;
  border: none;
  border-radius: 25px;
  padding: 11px 0;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  background: #ccc;
  line-height: 22px;
  cursor: not-allowed;
  flex-shrink: 0;
}

.notice-btn-active {
  background: #4fa4d3;
  cursor: pointer;
}
</style>
